import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { totalUsers } from "../../../data/data";

const NewHeroArea = () => {
  return (
    <section className="hero-v2">
      <div className="hero-glow"></div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="hero-content-v2">
              <motion.span
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="mb-3 d-inline-block"
                style={{
                  color: "#75DAB4",
                  fontWeight: 600,
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  fontSize: "14px",
                }}
              >
                An AI Product Studio
              </motion.span>

              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="gradient-text"
              >
                We Build AI Products <br /> People Actually Use
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="hero-subtitle"
              >
                DLPlatforms Pty Ltd is the company behind three live AI
                products: DLSurf, FitHisaab and Automyc. Together they serve
                more than {totalUsers.toLocaleString()} users across creator
                monetization, health and workflow automation.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.6 }}
                className="hero-btns d-flex flex-wrap justify-content-center gap-3"
              >
                <div className="cmn-btn">
                  <a href="#products">Explore the Portfolio</a>
                  <div className="line-1"></div>
                  <div className="line-2"></div>
                </div>
                <div className="cmn-btn layout-two">
                  <a
                    href="https://calendly.com/arjun-zcax/dlplatforms"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    Investor Enquiries <ChevronRight size={18} />
                  </a>
                  <div className="line-1"></div>
                  <div className="line-2"></div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
          className="team-image-container"
        >
          <div className="team-image-wrapper floating-element">
            <img
              src={process.env.PUBLIC_URL + "/img/hero-banner.jpg"}
              alt="The DLPlatforms team"
              loading="lazy"
            />
            <div className="image-mask"></div>
          </div>

          {/* Decorative Elements */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "120%",
              height: "100%",
              background:
                "radial-gradient(circle, rgba(117, 218, 180, 0.05) 0%, transparent 60%)",
              transform: "translate(-50%, -50%)",
              zIndex: -1,
            }}
          ></div>
        </motion.div>
      </div>

      <div
        className="scroll-indicator"
        style={{
          position: "absolute",
          bottom: "30px",
          left: "50%",
          transform: "translateX(-50%)",
          opacity: 0.5,
        }}
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          style={{
            width: "2px",
            height: "40px",
            background: "linear-gradient(to bottom, #75DAB4, transparent)",
          }}
        ></motion.div>
      </div>
    </section>
  );
};

export default NewHeroArea;
